<template>
  <div>
    <v-btn small @click="dialog=!dialog" class="themed">Ajouter un sous-groupe</v-btn>
    <v-dialog v-model="dialog" max-width="980px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Ajouter un sous-groupe</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-alert v-if="error" type="error">{{error}}</v-alert>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="model.name"
                  label="Nom"
                  hide-details="auto"
                  :rules="[mandatoryRules]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="model.canBuyCredit"
                  label="Autoriser les manager du groupe à créditer le compte ?"
                  false-value="no"
                  true-value="yes"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="close()" class="themed">Fermer</v-btn>
          <v-spacer></v-spacer>
          <v-btn small @click="submit()" class="primary themed">Ajouter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {},
  data: () => ({
    dialog: false,
    error: null,
    model: {
      name: null,
      parent_id: null,
      canBuyCredit: "no"
    },
    mandatoryRules: v => !!v || "Ce champ est obligatoire"
  }),
  props: {
    groupId: {
      type: Number,
      required: true
    }
  },
  mounted() {
    this.model.parent_id = this.groupId;
  },
  methods: {
    ...mapActions("group", ["create"]),
    submit() {
      this.create(this.model)
        .then(data => {
          this.dialog = false;
          this.$emit("succes", data);
        })
        .catch(error => {
          this.error = error.error;
        });
    },
    close() {
      this.dialog = false;
    },
    ...mapActions("stripes", ["sendTokenToServer"])
  }
};
</script>

<style>
</style>